/* IMPORT */
import channel from './channel.js';
/* MAIN */
const blue = (color) => {
    return channel(color, 'b');
};
/* EXPORT */
export default blue;
